import API_BASE_URL from '../config';

export interface Product {
  upc: string;
  name: string;
  brand?: string;
  price?: number;
  image_url?: string;
  category?: string;
  size?: string;
}

export interface ProductLookupResponse {
  success: boolean;
  product?: Product;
  cached?: boolean;
  source?: string;
  allow_manual_entry?: boolean;
  error?: string;
  upc?: string;
}

/**
 * Look up product information by UPC/EAN barcode
 */
export const lookupProductByUPC = async (token: string, upc: string): Promise<ProductLookupResponse> => {
  try {

    const response = await fetch(`${API_BASE_URL}/api/products/lookup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ upc })
    });

    if (!response.ok) {
      if (response.status === 404) {
        // Product not found - this is expected, return the error response
        const data = await response.json();
        return data;
      }
      throw new Error(`Product lookup failed: ${response.statusText}`);
    }

    const data = await response.json();
    return data;

  } catch (error: any) {
    console.error('[ProductService] Lookup failed:', error);
    return {
      success: false,
      error: error.message || 'Failed to lookup product',
      allow_manual_entry: true
    };
  }
};

/**
 * Save manually entered product to cache
 */
export const saveManualProduct = async (token: string, product: Partial<Product>): Promise<boolean> => {
  try {

    // This would save to the products table via a new endpoint
    // For now, we'll just return true and let the item creation handle it
    // TODO: Implement POST /api/products endpoint for manual entries
    
    console.log('[ProductService] Manual product saved:', product);
    return true;

  } catch (error) {
    console.error('[ProductService] Save failed:', error);
    return false;
  }
};
